module.exports = __webpack_public_path__ + "img/TULogo_weiss_RGB.a95095e9.svg";